var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "profile",
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 21.079,
    viewBox: "0 0 17 21.079",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union_9",
    "data-name": "Union 9",
    d: "M.585,21.079A.588.588,0,0,1,0,20.495a8.938,8.938,0,0,1,2.486-6.311A8.335,8.335,0,0,1,8.5,11.673a8.336,8.336,0,0,1,6.014,2.515A8.916,8.916,0,0,1,17,20.494a.588.588,0,0,1-.585.585Zm2.734-6.072a7.716,7.716,0,0,0-2.13,4.9H15.8a7.7,7.7,0,0,0-2.131-4.9A7.177,7.177,0,0,0,8.5,12.848,7.177,7.177,0,0,0,3.319,15.008Zm1.41-5.9A5.332,5.332,0,1,1,8.5,10.668,5.3,5.3,0,0,1,4.729,9.1Zm.829-6.712A4.16,4.16,0,1,0,8.5,1.171,4.145,4.145,0,0,0,5.558,2.392Z",
    transform: "translate(0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.8fbb53765a1ab5b5d46a797a057b6f84.svg";
export { ForwardRef as ReactComponent };